const mainTheme = {
  palette: {
    primary: {
      main: '#9E0220',
    },
  },
};

export default mainTheme;
